import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SelectedAccountContext } from "../../../Context/SelectedAccountContext/SelectedAccountContext";
import getCurrentUserInformation from "../../../GraphQL/Query/getCurrentUserInformation";
import { AdminRightActionsContainer } from "../../Admin/AdminRightActionsContainer/AdminRightActionsContainer";
import { Icon } from "../../Icon/Icon";
import { Button } from "../../SharedComponents/Button/Button";
import { SearchBox } from "../../SharedComponents/SearchBox/SearchBox";
import { UserChangeAccountButton } from "../UserChangeAccountButton/UserChangeAccountButton";
import { UserProfileDetails } from "../UserProfileDetails/UserProfileDetails";
import "./UserAccounts.css";

export const UserAccounts = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { selectedAccount, setSelectedAccount } = useContext(
    SelectedAccountContext
  );

  const { data: currentUser } = useQuery(getCurrentUserInformation);

  const { data } = useQuery(getAccountsQuery);

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (data?.accounts?.length > 0 && !selectedAccount) {
      setSelectedAccount(data?.accounts[0]);
    }
  }, [data, selectedAccount, setSelectedAccount]);

  const canInviteNewUsers =
    currentUser?.user.roles?.sso?.find(
      (x) => x.accountId === selectedAccount?.id
    )?.role !== "CUSTOMER";

  return (
    <div className="UserAccounts">
      <div className="UserAccounts__content">
        <div className="UserAccounts__header">
          <div className="UserAccounts__header--static">
            {t("generic.accounts")}
          </div>
          <div className="UserAccounts__header--account">
            <div className="UserAccounts__header--account-name">
              {selectedAccount?.name || "-"}
            </div>
            {data?.accounts && data?.accounts?.length > 1 && (
              <div className="UserAccounts__header__account-change">
                <UserChangeAccountButton
                  accounts={data?.accounts}
                  setSelectedAccount={(account) => {
                    setSelectedAccount(account);
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <UserProfileDetails accountId={selectedAccount?.id} />
      </div>
      {canInviteNewUsers && (
        <div className="AdminDistributors__right">
          <div className="AdminDistributors__search">
            <SearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>

          <div className="AdminDistributors__actions">
            <AdminRightActionsContainer>
              <div className="AdminDistributors__add-new">
                <Button
                  buttonStyle="Button__primary"
                  click={() =>
                    history.push(
                      `/sso/accounts/${selectedAccount.id}/invite-user`
                    )
                  }
                >
                  <Icon
                    className="AdminRightActionsContainer__add-new--icon"
                    name="iconAdd"
                    width={12}
                    height={12}
                  />
                  <div className="AdminRightActionsContainer__add-new--text">
                    {t("users.inviteUser")}
                  </div>
                </Button>
              </div>
            </AdminRightActionsContainer>
          </div>
        </div>
      )}
    </div>
  );
};

const getAccountsQuery = gql`
  query {
    accounts {
      id
      name
    }
  }
`;
